// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

import { useEffect, useState } from 'react';
import { brandService, type BrandConfig } from '@/api/brandService';

export function useBrand(): BrandConfig {
  // Lazy initializer şart — brandService.cached() çağrısı brandFromSubdomain ile her sefer
  // yeni object yaratıyor; lazy form ile yalnızca ilk render'da hesaplanır.
  const [brand, setBrand] = useState<BrandConfig>(() => brandService.cached());

  useEffect(() => {
    let iptal = false;
    brandService.get().then((b) => {
      // API'den gelen brand sidebar+entityLabels dolu — subdomain-based initial'da bunlar boş.
      // Smart skip yapmıyoruz: API response'unu HER ZAMAN state'e koy.
      // brandService.get() ikinci çağrıdan itibaren cached object döner → object identity stabil.
      if (!iptal) setBrand(b);
    });
    return () => { iptal = true; };
  }, []);

  return brand;
}

/**
 * Brand'in CSS değişkenlerini, page title'ı ve favicon'ı doküman köküne uygular.
 * AppLayout mount'unda bir kez çağrılır.
 */
export function applyBrandCssVars(brand: BrandConfig): void {
  const root = document.documentElement;
  root.style.setProperty('--brand-primary', brand.primaryColor);
  root.style.setProperty('--brand-accent', brand.accentColor);

  // Favicon ve sekme adı brandService'te, marka çözülür çözülmez uygulanır (login dahil her
  // ekranda geçerli olsun diye). Burada tekrar yazılmaz — aynı iş iki yerde durmasın.
}

/**
 * Subdomain "yikamatik" gibi brand-defined sidebar varsa true döner.
 * Bu durumda dinamik MenuController çağrısı yapılmaz, brand.sidebar render edilir.
 */
export function hasBrandSidebar(brand: BrandConfig): boolean {
  return brand.sidebar.length > 0;
}
